import React from "react";
import NumberFormat from "react-number-format";
import MaskedInput from "react-text-mask";
import { Functions } from "./functions";
export interface NumberFormatCustomProps {
	inputRef: (instance: NumberFormat | null) => void;
	onChange: (event: { target: { value: string } }) => void;
	length: number;
	max?: number;
	min?: number;
}

const numberDecimalFormatAllowed =
	(other) =>
	(values: import("react-number-format").NumberFormatValues): boolean => {
		const { formattedValue, floatValue } = values;
		if (floatValue === undefined || floatValue === null) {
			return !formattedValue || formattedValue === "";
		}
		const length = other.length ? other.length : 12;
		const inteiro = formattedValue.split(",")[0];
		return length - 2 >= Functions.removerFormatacao(inteiro).length;
	};

export function NumberFormatCustom(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values): void => {
				onChange({
					target: {
						value: values.value,
					},
				});
			}}
			decimalSeparator=","
			allowNegative={false}
			maxLength={other.length ? other.length : 12}
		/>
	);
}
export function NumberFormatCustomMoeda(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			format={Functions.formatMoeda}
			decimalScale={2}
			thousandSeparator="."
			decimalSeparator=","
			isNumericString={true}
			allowNegative={false}
			onValueChange={(valuesMoeda): void => {
				onChange({
					target: {
						value: valuesMoeda.value,
					},
				});
			}}
			isAllowed={numberDecimalFormatAllowed(other)}
		/>
	);
}


function numberToMoney(value: number | undefined): string {
	if (value) {
		const newValue = value.toFixed(2).split(".");
		newValue[0] = newValue[0].split(/(?=(?:...)*$)/).join(".");
		return newValue.join(",");
	} else {
		return "0,00";
	}
}

function masckMoney(value): number {
	let v = `${value}`;
	v = v.replace(/\D/g, "");
	v = `${parseFloat(v)}`;
	const len = v.length;
	if (1 === len) v = v.replace(/(\d)/, "0.0$1");
	else if (2 === len) v = v.replace(/(\d)/, "0.$1");
	else if (len > 2) {
		v = v.replace(/(\d{2})$/, ".$1");
	}
	return parseFloat(v);
}

function formatMoedaNoPrefix(value): string {
	return `${numberToMoney(masckMoney(value))}`;
}

export function NumberFormatCustomMoedaNoPrefix(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			format={formatMoedaNoPrefix}
			isNumericString={true}
			allowNegative={false}
			
		/>
	);
}


export function NumberFormatCustomDecimal(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			format={Functions.formatDecimal}
			decimalScale={2}
			thousandSeparator="."
			decimalSeparator=","
			isNumericString={true}
			allowNegative={false}
			onValueChange={(valuesMoeda): void => {
				onChange({
					target: {
						value: valuesMoeda.value,
					},
				});
			}}
			isAllowed={numberDecimalFormatAllowed(other)}
		/>
	);
}

export function NumberFormatCustomPorcentagem(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			thousandSeparator="."
			decimalSeparator=","
			decimalScale={2}
			fixedDecimalScale={true}
			isNumericString={true}
			allowNegative={false}
			onValueChange={(numro): void => {
				onChange({
					target: {
						value: numro.value,
					},
				});
			}}
			isAllowed={(values): boolean => {
				const { formattedValue, floatValue } = values;
				if (floatValue === undefined || floatValue === null) {
					return !formattedValue || formattedValue === "";
				}
				return floatValue < (other.max ? other.max : 1000) && floatValue >= (other.min ? other.min : 0);
			}}
		/>
	);
}

export function NumberDecimalFormatCustom(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			thousandSeparator="."
			decimalSeparator=","
			decimalScale={2}
			isNumericString={true}
			allowNegative={false}
			onValueChange={(numro): void => {
				onChange({
					target: {
						value: numro.value,
					},
				});
			}}
			isAllowed={numberDecimalFormatAllowed(other)}
		/>
	);
}
export function NumberFormatCustomNumeric(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(fields): void => {
				onChange({
					target: {
						value: fields.value,
					},
				});
			}}
			decimalScale={0}
			isNumericString={true}
			decimalSeparator=","
			allowNegative={false}
			maxLength={other.length ? other.length : 12}
		/>
	);
}

export function RealFormat(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(fields): void => {
				onChange({
					target: {
						value: fields.floatValue !== undefined ? fields.floatValue.toString() : "",
					},
				});
			}}
			decimalScale={2}
			isNumericString={true}
			decimalSeparator=","
			thousandSeparator="."
			allowNegative={false}
			isAllowed={numberDecimalFormatAllowed(other)}
		/>
	);
}

export function RealFormatRefactory(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(fields): void => {
				onChange({
					target: {
						value: fields.floatValue !== undefined ? fields.floatValue.toString().replace(".", ",") : "",
					},
				});
			}}
			decimalScale={2}
			isNumericString={true}
			decimalSeparator=","
			thousandSeparator="."
			allowNegative={false}
			isAllowed={numberDecimalFormatAllowed(other)}
		/>
	);
}


export function RealCurrencyFormat(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(fields): void => {
				onChange({
					target: {
						value: fields.floatValue !== undefined ? fields.floatValue.toString() : "",
					},
				});
			}}
			decimalScale={2}
			isNumericString={true}
			decimalSeparator=","
			thousandSeparator="."
			allowNegative={false}
			prefix="R$"
			isAllowed={numberDecimalFormatAllowed(other)}
		/>
	);
}

export function NumberFormatCoordenada(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(fields): void => {
				onChange({
					target: {
						value: fields.value,
					},
				});
			}}
			decimalScale={6}
			isNumericString={true}
			decimalSeparator=","
			allowNegative={true}
			maxLength={other.length ? other.length : 12}
		/>
	);
}

export function TextMaskCustom(props): JSX.Element {
	const { inputRef, ...other } = props;
	return (
		<MaskedInput
			{...other}
			ref={(ref: any): void => {
				inputRef(ref ? ref.inputElement : null);
			}}
			mask={[/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/]}
		/>
	);
}
export function TextMaskCPF(props): JSX.Element {
	const { inputRef, ...other } = props;
	return (
		<MaskedInput
			{...other}
			ref={(ref: any): void => {
				inputRef(ref ? ref.inputElement : null);
			}}
			mask={[/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/]}
		/>
	);
}




export function TextMaskCoordenadaLatitude(props): JSX.Element {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref: any): void => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[
				"S",
                /[0-9]/, // Aceita qualquer dígito de 0 a 9
                /\d/, // Aceita qualquer dígito de 0 a 9
                "°",
                /[0-5]/, // Aceita qualquer dígito de 0 a 5
                /\d/, // Aceita qualquer dígito de 0 a 9
                "'",
                /[0-5]/, // Aceita qualquer dígito de 0 a 5
                /\d/, // Aceita qualquer dígito de 0 a 9
                "''"
            ]}
            pipe={value => {
                const intValue = parseInt(value.replace(/\D/g, ''), 10);
                return intValue <= 900000 ? value : '';
            }}
        />
    );
}



export function TextMaskCoordenadaLongitude(props): JSX.Element {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref: any): void => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[
				"W",
                /\d/, // Aceita qualquer dígito de 0 a 9
                /\d/, // Aceita qualquer dígito de 0 a 9
                "°",
                /[0-5]/, // Aceita qualquer dígito de 0 a 5
                /\d/, // Aceita qualquer dígito de 0 a 9
                "'",
                /[0-5]/, // Aceita qualquer dígito de 0 a 5
                /\d/, // Aceita qualquer dígito de 0 a 9
                "''"
            ]}
            pipe={value => {
                const intValue = parseInt(value.replace(/\D/g, ''), 10);
                return intValue <= 900000 ? value : '';
            }}
        />
    );
}





const maskCustom = function (rawValue): (string | RegExp)[] {
	const onlyNumber = Functions.removeMask(rawValue);
	let lRetornoCustom = ["(", /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
	if (onlyNumber.length > 10) {
		lRetornoCustom = ["(", /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
	}
	return lRetornoCustom;
};

export function PhoneNumberMask(props): JSX.Element {
	const { inputRef, ...other } = props;
	return (
		<MaskedInput
			{...other}
			ref={(ref): void => {
				inputRef(ref ? ref.inputElement : null);
			}}
			mask={maskCustom}
		/>
	);
}

export function CEPNumberMask(props): JSX.Element {
	const { inputRef, ...other } = props;
	const maskCustom1 = [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
	return (
		<MaskedInput
			{...other}
			ref={(ref): void => {
				inputRef(ref ? ref.inputElement : null);
			}}
			mask={maskCustom1}
		/>
	);
}
export function NumberFormatCpfOrCnpj(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			format={Functions.maskCpfCnpj}
			isNumericString={true}
			allowNegative={false}
			getInputRef={inputRef}
			onValueChange={(valuesCpfOrCnpj): void => {
				onChange({
					target: {
						value: valuesCpfOrCnpj.value,
					},
				});
			}}
		/>
	);
}

export function NumberFormatCpnj2(props: NumberFormatCustomProps): JSX.Element {
	const { inputRef, onChange, ...other } = props;
	return (
		<NumberFormat
			{...other}
			format={Functions.formatCpnj}
			isNumericString={true}
			allowNegative={false}
			getInputRef={inputRef}
			onValueChange={(valuesCpfOrCnpj): void => {
				onChange({
					target: {
						value: valuesCpfOrCnpj.value,
					},
				});
			}}
			isAllowed={(values): boolean => {
				const { formattedValue, floatValue } = values;
				if (floatValue === undefined || floatValue === null) {
					return !formattedValue || formattedValue === "";
				}
				return floatValue >= 0 && floatValue.toString().length <= 14;
			}}
		/>
	);
}
export function NumeroAsMaskFormat(props): JSX.Element {
	const { inputRef, ...other } = props;
	return (
		<MaskedInput
			{...other}
			ref={(ref: any): void => {
				inputRef(ref ? ref.inputElement : null);
			}}
			mask={[/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ".", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ".", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]}
			keepCharPositions
			showMask
		/>
	);
}

export function DateMonthYearFormat(props): JSX.Element {
	const { inputRef, ...other } = props;
	return (
		<MaskedInput
			{...other}
			ref={(ref: any): void => {
				inputRef(ref ? ref.inputElement : null);
			}}
			mask={[/[0-9]/, /[0-9]/, "/", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]}
			keepCharPositions
			showMask
		/>
	);
}

export function NumberFormatNumeroAs(event: any): void {
	let value: string = event.target.value;
	value = value ? value.replace(/\D/g, "") : "";
	if (value.length === 12) {
		event.target.value = value.replace(/(\d{4})(\d{4})(\d{4})/, "$1.$2.$3");
	} else {
		event.target.value = value;
	}
}

export function NumberFormatLaudo(event: any): void {
	const value: string = event.target.value;
	event.target.value = value.replace(/[^A-Za-z0-9.]/g, "");
}

export function NumberFormatCpf(event: any): void {
	event.target.value = Functions.formatCpf(event.target.value);
}

export function NumberFormatCnpj(event: any): void {
	event.target.value = Functions.formatCpnj(event.target.value);
}

export function NumberFormatSicadOrCpfOrCnpj(event: any): void {
	let value: string = event.target.value;
	value = value ? value.replace(/\D/g, "") : "";
	if (value.length === 11) {
		NumberFormatCpf(event);
	} else if (value.length === 14) {
		NumberFormatCnpj(event);
	} else {
		event.target.value = value;
	}
}

export function FormatNomeOrCnpj(event: any): void {
	let value = event.target.value;
	value = value ? value.replace(/[./-]/g, "") : "";
	if (!isNaN(value)) {
		if (value.length === 14) {
			event.target.value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
		} else {
			event.target.value = value;
		}
	} else {
		event.target.value = value;
	}
}
